import { render, staticRenderFns } from "./BlocoSection.vue?vue&type=template&id=4f9ae172&scoped=true"
import script from "./BlocoSection.vue?vue&type=script&lang=js"
export * from "./BlocoSection.vue?vue&type=script&lang=js"
import style0 from "./BlocoSection.vue?vue&type=style&index=0&id=4f9ae172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9ae172",
  null
  
)

export default component.exports